if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"root","remotes":[{"alias":"settlement","name":"settlement","entry":"https://camerafi-settlement-admin-staging.web.app/remoteEntry.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(2604|3244|3323|6979)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}